export function offsetsOverlap(a, b) {
	const hasVerticalOverlap = !(b.bottom <= a.top || a.bottom <= b.top);
	const hasHorizontalOverlap = !(b.right <= a.left || a.right <= b.left);

	return hasVerticalOverlap && hasHorizontalOverlap;
}
